import React from 'react';
import CircularProgress from 'material-ui/Progress/CircularProgress';
import Console from '../../lib/debug';

const LoadingState = props => {
    Console.render('LoadingState');

    const textStyle = {};
    if (props.textSize) {
        textStyle.fontSize = props.textSize;
    }

    const iconStyle = {};
    if (props.iconSize) {
        iconStyle.fontSize = props.iconSize;
    }
    return (
        <div className="loading-state layout-align-center-center layout-column">
            <span>
                <CircularProgress
                    style={{
                        height: 50,
                        width: 50
                    }}
                />
            </span>
            <span style={textStyle}>{props.text || 'LOADING'}</span>
        </div>
    );
};

export default LoadingState;



// WEBPACK FOOTER //
// ./src/view/common/LoadingState.jsx